export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Display Currency"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Amounts are converted at available exchange rates. For custom currency rates are set by emitters and are indicative; the liquidity is not guaranteed."])}
}